module.exports = __webpack_public_path__ + "assets/align-left.17fd7c72.svg";